// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-TteV","card__name":"Card_card__name__VFLHO"};